import React from 'react';
import styled from 'styled-components';

import { Link } from '../components/text';

export default ({ icon, name, description, linkText, linkTarget, isLarge }) => {
  const Root = styled.div`
    align-items: flex-start;
    color: ${props => props.theme.color.gray19};
    display: flex;
    flex-direction: column;
    width: 20%;
  `;

  const LinkRoot = styled.a`
    align-items: center;
    display: flex;
    text-decoration: none;
    color: ${props => props.theme.color.sharePointTeal};
  `;

  const Image = styled.img`
    ${!isLarge &&
      `
      margin-right: 16px;
      width: 32px;
      height: 32px;
    `};

    ${isLarge &&
      `
      margin-bottom: 40px;
      width: 80px;
      height: 80px;
    `};
  `;

  const Name = styled.span`
    display: block;
    font-size: 14px;
    font-weight: ${props => props.theme.font.weight.semibold};

    ${props =>
      isLarge &&
      `
      margin-bottom: 24px;
      font-size: 24px;
    `};
  `;

  const Description = styled.span`
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 24px;
    flex-grow: 1;
  `;

  return isLarge ? (
    <Root>
      <Image src={icon} />
      <Name>{name}</Name>
      <Description>{description}</Description>
      <Link href={linkTarget}>{linkText}</Link>
    </Root>
  ) : (
    <LinkRoot href={linkTarget}>
      <Image src={icon} />
      <Name>{name}</Name>
    </LinkRoot>
  );
};



// WEBPACK FOOTER //
// ./src/components/toolkit.js